import React, { useEffect, useState } from 'react';
import {Grid, Box, Modal, Typography, Button, FormControl, TextField} from "@mui/material";
import { styles } from "./styles";
import CloseIcon from '@mui/icons-material/Close';
import MuiSelect from "components/MuiSelect/MuiSelect";
import CheckGroup from './CheckGroup';
import {getAllRoles, addUserApi, editUserApi, deleteUser} from 'apis/user';
import { Colors } from "assets/colors";
import { convertCompilerOptionsFromJson, idText } from 'typescript';
import { cp } from 'fs';
import TruckMuiSelect from "../../MuiSelect/TruckMuiSelect";
import CommonUtil from "../../../common/CommonUtil";
import ToastManager from "../../../common/ToastManager";
import DeleteModal from "../../../common/DeleteModal";

interface InputType {
  type: string,
  placeholder: string,
  disabled?: boolean,
  label?: string,
  size: number,
  value: string | undefined,
  key: string
}

interface SelectType {
  size: number,
  options: Array<string>,
  value: any,
  key: string,
}

interface AddUserModalProps {
  open: boolean;
  handleClose: Function | any;
  getUsers: Function;
  userToEdit?: any;
}

interface UserRole {
  application: string,
  roleId?: number,
  roleName: string,
  userId?: string
}

interface UserInfo {
  [key: string]: any,
  dateFormat: string,
  email: string,
  firstName: string,
  lastName: string,
  numberFormat: string,
  phoneNumber?: string,
  timeZone: string,
  userRoleList: Array<UserRole>,
  userStatus: string,
}

const defaultUser = {
  dateFormat: "",
  email: "",
  firstName: "",
  lastName: "",
  numberFormat: "",
  phoneNumber: "",
  timeZone: "",
  userRoleList: [],
  userStatus: "Active",
}

const AddUserModal: React.FC<AddUserModalProps> = ({ open, handleClose, getUsers, userToEdit }) => {
  const [roleList, setRoleList] = useState<any>([]);
  const [userData, setUserData] = useState<UserInfo>(defaultUser);
  const [error, setError] = useState("");
  const [apiError, setApiError] = useState("");
  const [missingFields, setMissingFields] = useState<Array<string>>([]);

  const [firstName,setFirstName] = useState("");
  const [firstNameErr,setFirstNameErr] = useState(true);

  const [lastName,setLastName] = useState("");
  const [lastNameErr,setLastNameErr] = useState(true);

  const [email,setEmail] = useState("");
  const [emailErr,setEmailErr] = useState(true);

  const [phoneNumber,setPhoneNumber] = useState<any>("");

  const [truckStatuses,setTruckStatuses] = useState<any>(CommonUtil.statuses);
  const [userStatus,setUserStatus] = useState<any>({key: "Active", value: "Active"});
  const [statusError,setStatusError] = useState(false);

  const [delUser,setDeleteUser] = useState(false);


  useEffect(() => {
    if (userToEdit !== undefined) {
      console.log(userToEdit);
      setFirstName(userToEdit.firstName);
      setLastName(userToEdit.lastName);
      setPhoneNumber(userToEdit.phoneNumber);
      setEmail(userToEdit.email);
      setEmailErr(false);
      setLastNameErr(false);
      setFirstNameErr(false);
      setUserStatus({key:userToEdit.userStatus,value:userToEdit.userStatus});
      if(userToEdit.userStatus){
        setStatusError(false);
      }

      setUserData(userToEdit);
    }
  }, [userToEdit]);

  // useEffect(() => {
  //   console.log(userData);
  // }, [userData]);

  useEffect(() => {
    const getRoles = async () => {
      let data = await getAllRoles();
      if (data) {
        let newData = data.filter((d: any) => d.roleStatus === 'Active');
        let newRoles: any = {};
        for (let i = 0; i < newData.length; i++) {
          if (newRoles[newData[i].applicationName] !== undefined) {
            newRoles[newData[i].applicationName] = { roleId: newData[i].roleId, roles: [...newRoles[newData[i].applicationName].roles, newData[i].roleName] }
          } else {
            newRoles[newData[i].applicationName] = { roleId: newData[i].roleId, roles: [newData[i].roleName] }
          }
        }
        setRoleList(newRoles);
      }
    }
    getRoles();
  }, []);

  const returnInput = (params: InputType) => {
    let { type, placeholder, disabled, label, value, key } = params;
    return (
      <Grid item xs={params.size} sx={styles.inputContainer}>
        {label && <Typography sx={styles.label}>{label}</Typography>}
        {type === "input" ?
          <>
            {/*<TextField id="outlined-basic" label={placeholder} variant="outlined" />*/}
          <input
              type="text"
              placeholder={placeholder}
              style={{ ...styles.input, border: missingFields.includes(key) ? `1px solid ${Colors.Red}` : `1px solid ${Colors.BorderGray}` }}
              disabled={disabled ? disabled : false}
              value={value}
              onChange={(e) => setUserData({ ...userData, [key]: e.target.value })}
            />

            {(error && key === "email") && <Typography sx={styles.error}>{error}</Typography>}
            {missingFields.includes(key) && <Typography sx={styles.error}>{placeholder} cannot be left empty.</Typography>}
          </>
          :
          <textarea style={styles.textarea} placeholder={placeholder}></textarea>
        }
      </Grid>
    )
  }

  const returnSelect = (params: SelectType) => {
    let { size, value, options, key } = params;
    return (
      <Grid item xs={size} sx={{ marginBottom: 0 }}>
        <MuiSelect
            label={"Status"}
          value={value}
          options={options}
          onChangeHandler={(val: any) => setUserData({ ...userData, [key]: val })}
        />
      </Grid>
    )
  };


  const updateList = (data: Array<UserRole>) => {
    setUserData({ ...userData, userRoleList: data });
  }

  const validateEmail = (email: string) => {
    setError("");
    if (email !== "") {
      const emailRegex = /^[^@\s!#$%&'()*+,./:;<=>?@[\\\]^_`{|}~-]+(?<!@rehrig)@rehrig\.com$/;
      let valid = emailRegex.test(email);
      if (!valid) {
        ToastManager.showToast("Invalid Email.","Error");
        //setError("Invalid Email.");
        return false;
      } else {
        setError("");
        return true
      }
    } else {
      //setError("Email cannot be left empty");
      ToastManager.showToast("Email cannot be left empty","Error");
      return false;
    }
  }

  const validateData = () => {
    let newFields = [];
    if (userData.lastName === "") {
      newFields.push("lastName");
    }
    if (userData.firstName === "") {
      newFields.push("firstName");
    }
    if (userData.userStatus === "") {
      newFields.push("userStatus");
    }
    if (userData.userRoleList.length === 0) {
      newFields.push("userRoleList");
    }
    setMissingFields(newFields);
    if (newFields.length > 0) {
      return false
    } else {
      return true;
    }
  }


  const submitNewUser = async () => {
    userData.firstName = firstName;
    userData.lastName = lastName;
    userData.email = email;
    userData.phoneNumber = phoneNumber;
    userData.userStatus = userStatus?userStatus.value:"";
    //console.log(userData);
    setApiError("");
    if (validateData() && validateEmail(userData.email) && userData.userStatus !== "") {
      let data = await addUserApi(userData);
      if (data?.response?.data?.errorMessage) {
       // setApiError(data?.response?.data?.errorMessage);
        ToastManager.showToast(data?.response?.data?.errorMessage,"Error");
      }else {
        handleClose();
        getUsers();
        ToastManager.showToast("User Created Successfully","Success");
      }
    }
  };

  const submitEditUser = async () => {
    userData.firstName = firstName;
    userData.lastName = lastName;
    userData.email = email;
    userData.phoneNumber = phoneNumber;
    userData.userStatus = userStatus?userStatus.value:"";
    console.log(userData);
    if (validateData() && validateEmail(userData.email)) {
      try {
        let data = await editUserApi(userData);
        if (data?.response?.data?.errorMessage) {
          ToastManager.showToast(data?.response?.data?.errorMessage,"Error");
          //setApiError("Something went wrong. User may already exist, or phone number has too many characters.");
        } else {
          handleClose();
          getUsers();
        }
      } catch (e) {
        handleClose();
        getUsers();
        ToastManager.showToast("User Updated Successfully","Success");
      }
    }

  }

  let onChangeFirstName = (data:any)=>{
    setFirstName(data);
    if(data){
      setFirstNameErr(false);
    }else{
      setFirstNameErr(true);
    }
  }

  let onChangeLastName = (data:any)=>{
    setLastName(data);
    if(data){
      setLastNameErr(false);
    }else{
      setLastNameErr(true);
    }
  }

  let onChangeEmail = (data:any)=>{
    setEmail(data);
    if(data){
      setEmailErr(false);
    }else{
      setEmailErr(true);
    }
  }

  let onChangePhoneNumber = (data:any)=>{
    const re = /^[0-9\b]+$/;
    if (data === '' || re.test(data)) {
      setPhoneNumber(data);
   }
  }
  let onChangeStatus = (data:any)=>{
    setUserStatus(data);
    if(data){
      setStatusError(false);
    }else{
      setStatusError(true);
    }
  }
  const handleUserDelete = ()=>{
    setDeleteUser(true);
  }

  let closeDelUserPopup = ()=>{
    setDeleteUser(false);
  }

  let handleDeleteUser = async (user:any)=>{
    console.log(user);
    if (user !== null) {
      let data = await deleteUser(user.userId);
      if (data?.response?.data?.errorMessage) {
        ToastManager.showToast(data?.response?.data?.errorMessage,"Error");
        //setApiError("Something went wrong. User may already exist, or phone number has too many characters.");
      } else {
        ToastManager.showToast("User Deleted Successfully","Success");
        handleClose();
        getUsers();
      }
    } else {
      //setIsLoading(false);
      getUsers();
      handleClose(false);
    }
  }



  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <>
        {delUser && <DeleteModal title={"Delete User"} open={delUser} handleDelete={handleDeleteUser} handlePopupClose={closeDelUserPopup} role={userToEdit} getList={getUsers} />}
        <Box sx={styles.container}>
          <Grid item xs={12} sx={styles.header}>
            <h2>{userToEdit !== undefined ? "Edit User" : "Add User"}</h2>
            <CloseIcon onClick={() => handleClose(false)} />
          </Grid>
          <Grid item xs={12}>
            {apiError !== "" && <Typography sx={styles.error}>{apiError}</Typography>}
            <Typography sx={styles.subHeader} style={{fontWeight:"bold"}}>User Details</Typography>
            <Grid container spacing={2} sx={styles.subContainer}>
              <Grid item xs={6}>
                <TextField style={{width:"100%",paddingBottom:"0px"}}   label={"First Name"}  value={firstName} inputProps={{ maxLength: 60 }}
                           onChange={(e) => onChangeFirstName(e.target.value)} required={true} error={firstNameErr} />
              </Grid>
              <Grid item xs={6}>
                <TextField style={{width:"100%",paddingBottom:"0px"}}  label={"Last Name"}  value={lastName} inputProps={{ maxLength: 60 }}
                           onChange={(e) => onChangeLastName(e.target.value)} required={true} error={lastNameErr} />
              </Grid>
              <Grid item xs={12}>
                <TextField  style={{width:"100%",paddingBottom:"0px"}}  label={"Email"}  value={email} inputProps={{ maxLength: 60 }}
                           onChange={(e) => onChangeEmail(e.target.value)} required={true} error={emailErr} />
              </Grid>
              <Grid item xs={6}>
                <TextField style={{width:"100%",paddingBottom:"0px"}}  label={"Phone Number(optional)"}  value={phoneNumber} inputProps={{ maxLength: 20 }}
                           onChange={(e) => onChangePhoneNumber(e.target.value)} required={false} error={false} />
              </Grid>
              <Grid item xs={6} sx={{ marginBottom: 0 }}>
                <TruckMuiSelect label={"Status"} sKey={"key"} value={"value"} selectedValue={userStatus}  dataSource={truckStatuses}
                                mandatory={true} iserror={statusError} onChangeHandler={(e: any) => onChangeStatus(e)} />
              </Grid>
              {/*returnInput({ type: "input", placeholder: "First Name", size: 6, value: userData.firstName, key: "firstName" })*/}
              {/*returnInput({ type: "input", placeholder: "Last Name", size: 6, value: userData.lastName, key: "lastName" })*/}
              {/*returnInput({ type: "input", placeholder: "Email", size: 12, value: userData.email, key: "email" })*/}
              {/*returnInput({ type: "input", placeholder: "Phone Number(optional)", size: 6, value: userData.phoneNumber, key: "phoneNumber" })*/}
              {/*returnSelect({ size: 6, options: ["Active", "Inactive"], value: userData.userStatus, key: "userStatus" })*/}
            </Grid>
            <Typography sx={styles.subHeader} style={{fontWeight:"bold"}}> Applications</Typography>
            {missingFields.includes("userRoleList") && <Typography sx={styles.error}>Select an application.</Typography>}
            <Grid item xs={12} sx={{ marginBottom: 0, maxHeight: "8rem", overflowY: "auto" }}>
              {
                Object.keys(roleList).map((r, i) =>
                  <CheckGroup userData={userData} product={r} updateList={updateList} roleList={roleList} key={i} userToEdit={userToEdit} />)

              }
            </Grid>
          </Grid>

          <Grid item xs={12} sx={styles.buttonContainer}>
            <Button sx={styles.cancelButton} onClick={() => handleClose(false)}>Cancel</Button>
            {(userToEdit && CommonUtil.isScreenButtonAvailable(CommonUtil.USER_MANAGEMENT,CommonUtil.UPDATE_MODE))?<Button sx={styles.deleteButton} onClick={() => handleUserDelete()}>Delete User</Button>:""}
            {(userToEdit && CommonUtil.isScreenButtonAvailable(CommonUtil.USER_MANAGEMENT,CommonUtil.UPDATE_MODE))?<Button sx={styles.addButton} onClick={submitEditUser}>Edit User</Button>:""}
            {!userToEdit?<Button sx={styles.addButton} onClick={submitNewUser}>Add User</Button>:""}
          </Grid>
        </Box>
      </>
    </Modal>
  )
}

export default AddUserModal;
